// extracted by mini-css-extract-plugin
export default {"block":"DottedRectangles-module--block--ef5a3","rectangles":"DottedRectangles-module--rectangles--0708b"};